import React from 'react'
import {
  IconArrowRight,
  IconBottomCustomSize,
  IconButtonSelectInactive,
  IconCancel,
  IconCaretDown,
  IconCheck,
  IconChangePicture,
  IconCircle,
  IconClose,
  IconCloseModalCustomSize,
  IconClosedPadlock,
  IconColor,
  IconConfirm,
  IconCopy,
  IconCrown,
  IconCustomSize,
  IconDelete,
  IconDownArrow,
  IconDownload,
  IconEmbed,
  IconEmbedEditor,
  IconFilter,
  IconFolder,
  IconGradient,
  IconHome,
  IconIframe,
  IconImage,
  IconIncorporate,
  IconLayers,
  IconLanguage,
  IconLeftArrow,
  IconLink,
  IconLogotipo,
  IconLogout,
  IconMagazine,
  IconMagazineMenuDelete,
  IconMagazineMenuDuplicate,
  IconMagazineMenuTransfer,
  IconMenuEllipsis,
  IconMinus,
  IconNotFound,
  IconOpacity,
  IconOpenEditor,
  IconPage,
  IconPageAdd,
  IconPageDuplicate,
  IconPageEdit,
  IconPages,
  IconPalette,
  IconPDF,
  IconPencil,
  IconPlus,
  IconPlusCircle,
  IconPreview,
  IconPublish,
  IconReturn,
  IconRemove,
  IconRhombus,
  IconRightArrow,
  IconSearch,
  IconSelectUnitSize,
  IconShape,
  IconSortDown,
  IconSortUp,
  IconSquare,
  IconText,
  IconTextAlignCenter,
  IconTextAlignLeft,
  IconTextAlignRight,
  IconTextAlignJustify,
  IconTextBold,
  IconTextColor,
  IconTextItalic,
  IconTextUnderline,
  IconTotalView,
  IconTopCustomSize,
  IconTriangle,
  IconVideo,
  IconView,
  IconViewBrowser,
  IconVimeo,
  IconWarning,
  IconWistia,
  IconYoutube,
  Paint,
  RightArrow,
  LeftArrow,
  NewPage,
  DoubleRightArrow,
  DoubleLeftArrow,
  CloseTag,
  Library,
  FromFront,
  FromBack,
  VerticalArrow,
  HorizontalArrow,
  FullBorder,
  DoubleBorder,
  SingleBorder,
  Nullable,
  ZoomMinus,
  ZoomPlus,
  Hiperlink,
  FontLetter,
  IconLine,
  ShapeArrow,
  ShapeStar,
  IconLineHeight,
  IconFontSize
} from '@/assets/svgicons'

const IconComponent = props => {
  switch (props.icon) {
    case 'arrow-right':
      return <IconArrowRight />
    case 'botton-custom-size-icon':
      return <IconBottomCustomSize />;
    case 'button-select-inactive':
      return <IconButtonSelectInactive />
    case 'cancel':
      return <IconCancel />
    case 'caret-down':
      return <IconCaretDown {...props} />
    case 'check':
      return <IconCheck />
    case 'change-picture':
      return <IconChangePicture />
    case 'circle':
      return <IconCircle />
    case 'close':
      return <IconClose />
    case 'close-modal-custom-size':
      return <IconCloseModalCustomSize />
    case 'closed-padlock':
      return <IconClosedPadlock />
    case 'color':
      return <IconColor {...props} />
    case 'confirm':
      return <IconConfirm />
    case 'copy':
      return <IconCopy />
    case 'crown':
      return <IconCrown />
    case 'custom-size':
      return <IconCustomSize />
    case 'delete':
      return <IconDelete />
    case 'down-arrow':
      return <IconDownArrow />
    case 'download':
      return <IconDownload />
    case 'embed':
      return <IconEmbed />
    case 'embed-editor':
      return <IconEmbedEditor />
    case 'filter':
      return <IconFilter />
    case 'folder':
      return <IconFolder />
    case 'gradient':
      return <IconGradient />
    case 'home':
      return <IconHome />
    case 'iframe':
      return <IconIframe />
    case 'image':
      return <IconImage />
    case 'incorporate':
      return <IconIncorporate />
    case 'layers':
      return <IconLayers />
    case 'language':
      return <IconLanguage />
    case 'left-arrow':
      return <IconLeftArrow />
    case 'link':
      return <IconLink />
    case 'logotipo':
      return <IconLogotipo />
    case 'logout':
      return <IconLogout />
    case 'magazine':
      return <IconMagazine />
    case 'magazine-menu-delete':
      return <IconMagazineMenuDelete />
    case 'magazine-menu-duplicate':
      return <IconMagazineMenuDuplicate />
    case 'magazine-menu-transfer':
      return <IconMagazineMenuTransfer />
    case 'menu-ellipsis':
      return <IconMenuEllipsis />
    case 'minus':
      return <IconMinus />
    case 'opacity':
      return <IconOpacity {...props} />
    case 'open-editor':
      return <IconOpenEditor />
    case 'page':
      return <IconPage />
    case 'page-add':
      return <IconPageAdd />
    case 'page-duplicate':
      return <IconPageDuplicate />
    case 'page-edit':
      return <IconPageEdit />
    case 'pages':
      return <IconPages />
    case 'palette':
      return <IconPalette />
    case 'pdf':
      return <IconPDF />
    case 'pencil-edit':
      return <IconPencil />
    case 'plus':
      return <IconPlus />
    case 'plus-circle':
      return <IconPlusCircle />
    case 'preview':
      return <IconPreview />
    case 'publish':
      return <IconPublish />
    case 'return':
      return <IconReturn />
    case 'remove':
      return <IconRemove />
    case 'rhombus':
      return <IconRhombus />
    case 'right-arrow':
      return <IconRightArrow />
    case 'search':
      return <IconSearch />
    case 'select-unit-size':
      return <IconSelectUnitSize />
    case 'shape':
      return <IconShape />
    case 'sort-down':
      return <IconSortDown />
    case 'sort-up':
      return <IconSortUp />
    case 'square':
      return <IconSquare />
    case 'text':
      return <IconText />
    case 'text-align-center':
      return <IconTextAlignCenter {...props} />
    case 'text-align-left':
      return <IconTextAlignLeft {...props} />
    case 'text-align-right':
      return <IconTextAlignRight {...props} />
    case 'text-align-justify':
      return <IconTextAlignJustify {...props} />
    case 'text-bold':
      return <IconTextBold {...props} />
    case 'text-color':
      return <IconTextColor {...props} />
    case 'text-italic':
      return <IconTextItalic {...props} />
    case 'text-underline':
      return <IconTextUnderline {...props} />
    case 'total-view':
      return <IconTotalView />
    case 'top-custom-size-icon':
      return <IconTopCustomSize />
    case 'triangle':
      return <IconTriangle />
    case 'video':
      return <IconVideo />
    case 'view':
      return <IconView />
    case 'view-browser':
      return <IconViewBrowser />
    case 'vimeo':
      return <IconVimeo />
    case 'warning':
      return <IconWarning />
    case 'wistia':
      return <IconWistia />
    case 'youtube':
      return <IconYoutube />
    case 'paint':
      return <Paint />
    case 'new-right-arrow':
      return <RightArrow />
    case 'new-left-arrow':
      return <LeftArrow />
    case 'new-page':
      return <NewPage />
    case 'double-right-arrow':
      return <DoubleRightArrow />
    case 'double-left-arrow':
      return <DoubleLeftArrow />
    case 'close-tag':
      return <CloseTag />
    case 'library':
      return <Library />
    case 'from-front':
      return <FromFront />
    case 'from-back':
      return <FromBack />
    case 'vertical-arrow':
      return <VerticalArrow />
    case 'horizontal-arrow':
      return <HorizontalArrow />
    case 'full-border':
      return <FullBorder />
    case 'double-border':
      return <DoubleBorder />
    case 'single-border':
      return <SingleBorder />
    case 'nullable':
      return <Nullable />
    case 'zoom-minus':
      return <ZoomMinus />
    case 'zoom-plus':
      return <ZoomPlus />
    case 'hiperlink':
      return <Hiperlink />
    case 'font-letter':
      return <FontLetter />
    case 'line':
      return <IconLine />
    case 'shape-arrow':
      return <ShapeArrow />
    case 'shape-star':
      return <ShapeStar />
    case 'line-height':
      return <IconLineHeight />
    case 'font-size':
      return <IconFontSize />
    default:
      return <IconNotFound />
  }
}

export default IconComponent



// WEBPACK FOOTER //
// ./src/components/commons/IconComponent.js